// Cartão "indicações para trabalhar" (Programa de Indicações): Cobrança e Pós-venda.
// Sem a permissão "Trabalhar indicações" o banco só mostra o que a pessoa registrou,
// então o cartão diz o que falta em vez de mostrar zero.
import React from 'react';
import type { Profile } from '../../types';
import { podeGerirIndicacoes } from '../../src/lib/indicacoes/permissoes';
import { CartaoHoje, plural } from './componentes';
import { useIndicacoesParaTrabalhar } from './useCobranca';

export const CartaoIndicacoes: React.FC<{ pessoa: Profile }> = ({ pessoa }) => {
  const pode = podeGerirIndicacoes(pessoa as any);
  const indicacoes = useIndicacoesParaTrabalhar(pode);
  if (!pode) {
    return (
      <CartaoHoje
        valor="—"
        rotulo="indicações para trabalhar"
        tom="neutro"
        para="/crm/indicacoes"
        dica={'Falta a permissão "Trabalhar indicações" (Config › Usuários) para abordar os clientes do Programa de Indicações.'}
      />
    );
  }
  return (
    <CartaoHoje
      valor={indicacoes.dados ? indicacoes.dados.voltarDepois : null}
      rotulo="clientes pediram para voltar (indicações)"
      tom="neutro"
      para="/crm/indicacoes"
      dica={indicacoes.dados ? `Clientes que pediram para ser procurados de novo no Programa de Indicações. Mais ${plural(indicacoes.dados.nuncaAbordados, 'cliente nunca abordado', 'clientes nunca abordados')}.` : undefined}
    />
  );
};
